"use client";

import Link from "next/link";
import Image from "next/image";

export function MarketingNav() {
  return (
    <nav className="sticky top-0 z-50 border-b border-gray-200 bg-white/80 backdrop-blur-sm">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 py-2 sm:py-3">
        <div className="flex items-center justify-between gap-3">
          <Link href="/" className="flex items-center gap-2 min-w-0">
            <Image
              src="/hirefitlogo-puzzle-rec.png"
              alt="HireFit Logo"
              width={1800}
              height={945}
              className="h-7 sm:h-8 w-auto shrink-0"
              priority
            />
          </Link>

          <div className="flex items-center gap-3 sm:gap-6 shrink-0">
            <a
              href="/about"
              className="hidden sm:inline text-sm text-gray-600 hover:text-gray-900 transition-colors"
            >
              About
            </a>
            <Link
              href="/features"
              className="hidden sm:inline text-sm text-gray-600 hover:text-gray-900 transition-colors"
            >
              Features
            </Link>

            <Link
              href="/login"
              className="inline-flex items-center rounded-lg bg-[#2a9695] px-3 sm:px-4 py-2 text-sm text-white hover:bg-[#78d0d0] hover:text-[#1c3d51] transition-colors"
            >
              Sign up or Login
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
}
